import React, { useState, useEffect } from "react";
import { Header } from "../../Header";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Pagination from "@mui/material/Pagination";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import Chip from "@mui/material/Chip";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import "./summary.css";
import { local_signage, local_url } from "../../Const";
import { saveAs } from "file-saver";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import * as XLSX from 'xlsx';
import { Tooltip } from '@mui/material';



const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const SaleSummary = () => {
    const [areas, setAreas] = useState([]);
    const [area, setArea] = useState("ALL");
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs());
    const [businessSegments, setBusinessSegments] = useState([]);
    const [businessSegment, setBusinessSegment] = useState("LAZIZ");
    const [viewType, setViewType] = useState("AREASUM");
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [error, setError] = useState(null);
    const [areasLoading, setAreasLoading] = useState(true);
    const [divisions, setDivisions] = useState([]);
    const [selectedDivisions, setSelectedDivisions] = useState([]);
    const [divisionsLoading, setDivisionsLoading] = useState(true);
    const [businessSegmentsLoading, setBusinessSegmentsLoading] = useState(true);
    const [selectedChannel, setSelectedChannel] = useState("ALL");
    const userId = localStorage.getItem('userId');

    const rowsPerPage = 100;
    const navigate = useNavigate();

    const handleTokenExpiration = () => {
        localStorage.clear();
        alert("Your session has expired. Please login again.");
        navigate("/login");
    };

    const handleDivisionChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedDivisions(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleChannelChange = (event) => {
        setSelectedChannel(event.target.value);
    };

    // Function to get filtered divisions based on business segment
    const getFilteredDivisions = () => {
        if (businessSegment === 'LAZIZ') {
            // For LAZIZ, exclude PRODUCT/PACKED
            return divisions.filter(div => div !== 'PRODUCT');
        } else if (businessSegment === 'MODERN') {
            // For MODERN (GTMT), show EGG, PRODUCT/PACKED, RTC, and POULTRY
            return divisions.filter(div => div === 'EGG' || div === 'PRODUCT' || div === 'RTC' || div === 'POULTRY');
        }
        // Default: return all divisions
        return divisions;
    };

    // Function to display division name (show PRODUCT as PACKED)
    const displayDivisionName = (division) => {
        return division === 'PRODUCT' ? 'PACKED' : division;
    };

    // Function to get available channels based on business segment
    const getAvailableChannels = () => {
        const allChannels = ["ALL", "WEB", "POS", "GT", "MP", "HORECA"];
        
        if (businessSegment === 'LAZIZ') {
            return ["ALL", "WEB", "POS", "HORECA"];
        } else if (businessSegment === 'MODERN') {
            return ["ALL", "GT", "MP", "HORECA"];
        } else if (businessSegment === 'RETAIL') {
            return ["ALL", "WEB", "POS", "HORECA"];
        }
        // For ALL segment, return all channels
        return allChannels;
    };

    // Function to apply current filters to raw data
    const applyFiltersToData = (data) => {
        console.log("Applying filters to data...");
        let transformedData;

        if (viewType === "LIST") {
            // Transform LIST view data
            const groupedData = data.groupSale.reduce((acc, item) => {
                // Filter by selected divisions if any are selected
                if (selectedDivisions.length > 0 && !selectedDivisions.includes(item.Division || "")) {
                    return acc;
                }

                // Filter by selected channel if not ALL
                if (selectedChannel !== "ALL") {
                    const salesChannel = (item.SalesChannel || '').toUpperCase();
                    if (salesChannel !== selectedChannel) {
                        return acc;
                    }
                }

                if (businessSegment === 'RETAIL' && item.Area !== '00004') {
                    return acc;
                }

                // Filter by business segment
              const salesChannel = (item.SalesChannel || "").toUpperCase();
if (businessSegment === 'MODERN' && salesChannel !== 'GT' && salesChannel !== 'MP' && salesChannel !== 'HORECA') {
    return acc;
} else if (businessSegment === 'LAZIZ' && salesChannel !== 'WEB' && salesChannel !== 'POS' && salesChannel !== 'HORECA') {
    return acc;
}


                const key = `${item.BusinessDate}-${item.Branchid}-${item.ItemId}-${item.Division || "Unknown"}-${salesChannel}`;
                if (!acc[key]) {
                    acc[key] = {
                        date: item.BusinessDate,
                        displayDate: formatDisplayDate(item.BusinessDate),
                        Branchid: item.Branchid,
                        branchName: data.branch.find(b => b.Branchid === item.Branchid)?.BranchName || item.Branchid,
                        itemId: item.ItemId,
                        itemName: data.material.find(m => m.ItemId === item.ItemId)?.MaterialName || item.ItemId,
                        division: item.Division || "Unknown",
                        salesChannel: salesChannel,
                        onlineQty: 0,
                        offlineQty: 0
                    };
                }

                const netQuantity = Number(item.Qty || 0) - Number(item.ReturnQty || 0);

                if (salesChannel === "WEB") {
                    acc[key].onlineQty += netQuantity;
                } else {
                    acc[key].offlineQty += netQuantity;
                }

                return acc;
            }, {});

            transformedData = Object.values(groupedData).map(item => ({
                date: item.date,
                displayDate: item.displayDate,
                Branchid: item.Branchid,
                branchName: item.branchName,
                itemId: item.itemId,
                itemName: item.itemName,
                division: item.division === "PRODUCT" ? "PACKED" : item.division,
                salesChannel: item.salesChannel,
                onlineQty: item.onlineQty.toFixed(3),
                offlineQty: item.offlineQty.toFixed(3),
                totalQty: (item.onlineQty + item.offlineQty).toFixed(3),
            }));

        } else if (viewType === "DAYBRSUM") {
            // Transform DAYBRSUM view data
            const groupedData = data.groupSale.reduce((acc, item) => {
                // Filter by selected divisions if any are selected
                if (selectedDivisions.length > 0 && !selectedDivisions.includes(item.Division || "")) {
                    return acc;
                }

                // Filter by selected channel if not ALL
                if (selectedChannel !== "ALL") {
                    const salesChannel = (item.SalesChannel || '').toUpperCase();
                    if (salesChannel !== selectedChannel) {
                        return acc;
                    }
                }

                // Add this after division filtering:
                if (businessSegment === 'RETAIL' && item.Area !== '00004') {
                    return acc;
                }

                // Filter by business segment
                const salesChannel = (item.SalesChannel || "").toUpperCase();
if (businessSegment === 'MODERN' && salesChannel !== 'GT' && salesChannel !== 'MP' && salesChannel !== 'HORECA') {
    return acc;
} else if (businessSegment === 'LAZIZ' && salesChannel !== 'WEB' && salesChannel !== 'POS' && salesChannel !== 'HORECA') {
    return acc;
}

                const key = `${item.BusinessDate}-${item.BranchID || item.Branchid}-${item.Division || "Unknown"}-${salesChannel}`;

                // Find the branch name from the branch array
                const branchInfo = data.branch.find(b =>
                    b.Branchid === (item.BranchID || item.Branchid)
                );
                const branchName = branchInfo
                    ? (branchInfo.BranchName || branchInfo.branchName || (item.BranchID || item.Branchid))
                    : (item.BranchID || item.Branchid);

                if (!acc[key]) {
                    acc[key] = {
                        date: item.BusinessDate,
                        displayDate: formatDisplayDate(item.BusinessDate),
                        Branchid: item.BranchID || item.Branchid,
                        branchName: branchName,
                        division: item.Division || "Unknown",
                        salesChannel: salesChannel,
                        posQty: 0,
                        onlineQty: 0
                    };
                }

                const netQuantity = Number(item.Qty || 0) - Number(item.ReturnQty || 0);

                if (salesChannel === 'WEB') {
                    acc[key].onlineQty += netQuantity;
                } else {
                    acc[key].posQty += netQuantity;
                }

                return acc;
            }, {});

            transformedData = Object.values(groupedData).map(item => ({
                ...item,
                posQty: item.posQty.toFixed(2),
                onlineQty: item.onlineQty.toFixed(2),
                totalQty: (item.posQty + item.onlineQty).toFixed(2)
            }));
        }
        else if (viewType === "AREASUM") {
            transformedData = transformAreaSummaryData(data, businessSegment, selectedChannel);
            // Update PRODUCT to PACKED in the transformed data
            transformedData = transformedData.map(item => ({
                ...item,
                division: item.division === "PRODUCT" ? "PACKED" : item.division
            }));
        }

        console.log("Transformed data:", transformedData);
        
        // Sort the transformed data
        const sortedData = sortData(transformedData);
        console.log("Final sorted data:", sortedData);
        
        setTableData(sortedData);
        setPage(1); // Reset to first page when filters change
    };

    const transformAreaSummaryData = (data, selectedSegment, selectedChannelParam = "ALL") => {
        console.log('Input data:', data);
        console.log('Selected business segment:', selectedSegment);

        // Create mappings for areas, branches, and materials
        const areaMap = {};
        data.area.forEach(area => {
            areaMap[area.Area] = area.SFAreaName;
        });

        const branchMap = {};
        data.branch.forEach(branch => {
            branchMap[branch.Branchid] = branch.BranchName;
        });

        const materialMap = {};
        data.material.forEach(material => {
            materialMap[material.ItemId] = material.MaterialName;
        });

        // Filter by selected divisions if any are selected
        let filteredSales = data.groupSale;
        if (selectedDivisions.length > 0) {
            filteredSales = data.groupSale.filter(item =>
                selectedDivisions.includes(item.Division || "")
            );
        }

        // Filter by selected channel if not ALL
        if (selectedChannelParam !== "ALL") {
            filteredSales = filteredSales.filter(item => {
                const salesChannel = (item.SalesChannel || '').toUpperCase();
                return salesChannel === selectedChannelParam;
            });
        }

        // Add this new filtering for RETAIL
        if (selectedSegment === 'RETAIL') {
            filteredSales = filteredSales.filter(item => item.Area === '00004');
        } else {
            // Exclude area 00004 for non-Retail business segments
            filteredSales = filteredSales.filter(item => item.Area !== '00004');
        }

        // Group sales data
        const groupedByArea = filteredSales.reduce((acc, item) => {
            const areaId = item.Area;
            const areaName = areaMap[areaId] || areaId;
            const branchName = branchMap[item.Branchid] || item.Branchid;
            const materialName = materialMap[item.ItemId] || item.ItemId;
            const division = item.Division || "Unknown";
            const salesChannel = (item.SalesChannel || '').toUpperCase();

            const key = `${areaId}-${item.Branchid}-${item.ItemId}-${division}-${salesChannel}`;

            if (!acc[key]) {
                acc[key] = {
                    areaId: areaId,
                    areaName: areaName,
                    Branchid: item.Branchid,
                    branchName: branchName,
                    itemId: item.ItemId,
                    materialName: materialName,
                    division: division,
                    salesChannel: salesChannel,
                    onlineWeight: 0,
                    offlineWeight: 0,
                };
            }

            // Calculate net quantity
            const quantity = Number(item.Qty || 0);
            const returnQty = Number(item.ReturnQty || 0);
            const netQuantity = quantity - returnQty;

            if (selectedSegment === 'LAZIZ') {
                // For LAZIZ, consider WEB as online, POS, HORECA and null/empty as offline
                if (salesChannel === 'WEB') {
                    acc[key].onlineWeight += netQuantity;
                } else if (salesChannel === 'POS' || salesChannel === 'HORECA' || !salesChannel) {
                    acc[key].offlineWeight += netQuantity;
                }
            } else if (selectedSegment === 'MODERN') {
                // For MODERN (GTMT), filter by GT, MP and HORECA channels
                if (salesChannel === 'GT' || salesChannel === 'MP' || salesChannel === 'HORECA') {
                    acc[key].offlineWeight += netQuantity;
                }
            } else if (selectedSegment === 'RETAIL') {
                // For RETAIL, include all channels from area 00004 (already filtered above)
                if (salesChannel === 'WEB') {
                    acc[key].onlineWeight += netQuantity;
                } else if (salesChannel === 'POS' || salesChannel === 'HORECA' || !salesChannel) {
                    acc[key].offlineWeight += netQuantity;
                }
            } else if (selectedSegment === 'ALL') {
                if (salesChannel === 'WEB') {
                    acc[key].onlineWeight += netQuantity;
                } else if (salesChannel === 'POS' || salesChannel === 'HORECA' || salesChannel === 'GT' || salesChannel === 'MP' || !salesChannel) {
                    acc[key].offlineWeight += netQuantity;
                }
            }

            return acc;
        }, {});

        // Transform into final format
        const result = Object.values(groupedByArea)
            .map(item => ({
                areaId: item.areaId || 'N/A',
                areaName: item.areaName || 'N/A',
                Branchid: item.Branchid || 'N/A',
                branchName: item.branchName || 'N/A',
                itemId: item.itemId || 'N/A',
                materialName: item.materialName || 'N/A',
                division: item.division || 'N/A',
                salesChannel: item.salesChannel || 'N/A',
                onlineWeight: Number(item.onlineWeight).toFixed(2),
                offlineWeight: Number(item.offlineWeight).toFixed(2),
                totalQty: (Number(item.onlineWeight) + Number(item.offlineWeight)).toFixed(2)
            }))
            .filter(item => Number(item.totalQty) > 0);

        console.log('Final transformed data:', result);
        return result;
    };

    useEffect(() => {
        const fetchAreas = async () => {
            setAreasLoading(true);
            setError(null);

            if (!local_url || !userId) {
                console.error("Missing required props:", { local_url, userId });
                setError("Configuration error: Missing required parameters");
                setAreasLoading(false);
                return;
            }

            try {
                console.log("Fetching areas with URL:", `${local_url}/api/SFArea/${userId}`);

                const response = await fetch(`${local_url}/api/SFArea/${userId}`, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log("Raw API response:", data);

                if (Array.isArray(data)) {
                    setAreas(data);
                } else {
                    console.error("Unexpected data format:", data);
                    setError("Invalid data format received from server");
                }
            } catch (error) {
                console.error("Error fetching areas:", error);
                setError(`Failed to fetch areas: ${error.message}`);
            } finally {
                setAreasLoading(false);
            }
        };

        fetchAreas();
        fetchDivisions();
        fetchBusinessSegments();
    }, [local_url, userId]);

    // Reset selected divisions, area and channel when business segment changes
    useEffect(() => {
        setSelectedDivisions([]);
        setArea("ALL");
        setSelectedChannel("ALL");
    }, [businessSegment]);

    // Store the raw data to re-filter when channel changes
    const [rawData, setRawData] = useState(null);

    // Auto-filter data when channel or divisions change (only if we already have raw data)
    useEffect(() => {
        if (rawData) {
            applyFiltersToData(rawData);
        }
    }, [selectedChannel, selectedDivisions]);

    const fetchBusinessSegments = async () => {
        setBusinessSegmentsLoading(true);
        const token = localStorage.getItem('AuthorizationToken');

        setError(null);

        try {
            const response = await fetch(`${local_url}/api/BizSegments`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) throw new Error("Failed to fetch Business Segments");

            const data = await response.json();
            setBusinessSegments(data);
        } catch (error) {
            console.error("Error fetching business segments:", error);
            setError("Failed to fetch Business Segments. Please try again later.");
        } finally {
            setBusinessSegmentsLoading(false);
        }
    };


    const fetchDivisions = async () => {
        setDivisionsLoading(true);
        setError(null);

        const token = localStorage.getItem('AuthorizationToken');

        if (!token) {
            handleTokenExpiration();
            return;
        }

        try {
            // This is a placeholder - you may need to replace this with the actual API endpoint
            const url = `${local_signage}/api/v1/divisions`;

            // If there's no specific API for divisions, we can use a sample list
            // or extract it from another API response

            // For demonstration, using hardcoded divisions
            // In production, replace this with actual API call:
            /*
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setDivisions(data);
            */

            // Sample divisions (replace with API call in production)
            const sampleDivisions = ["POULTRY", "EGG", "NONPOULTRY", "PRODUCT", "RTC"];
            setDivisions(sampleDivisions);

        } catch (error) {
            console.error("Error fetching divisions:", error);
            setError(`Failed to fetch divisions: ${error.message}`);
        } finally {
            setDivisionsLoading(false);
        }
    };

    const fetchReportData = async () => {
        setLoading(true);
        setError(null);

        const token = localStorage.getItem('AuthorizationToken');

        if (!token) {
            handleTokenExpiration();
            return;
        }

        try {
            const formattedStartDate = startDate.format('YYYYMMDD');
            const formattedEndDate = endDate.format('YYYYMMDD');

            const url = `${local_signage}/api/v1/b2csaleqty?Option=${viewType}&AreaID=${area}&SaleChannel=ALL&StartDate=${formattedStartDate}&EndDate=${formattedEndDate}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (response.status === 401 || response.status === 403) {
                handleTokenExpiration();
                return;
            }

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log("Raw API response:", data);
            
            // Store raw data for real-time filtering
            setRawData(data);
            
            // Apply filters to get initial table data using the new filtering function
            applyFiltersToData(data);

        } catch (error) {
            console.error("Error fetching report data:", error);
            if (error.message.includes("401")) {
                handleTokenExpiration();
                return;
            }
            setError(error.message || "Failed to fetch report data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const sortData = (data) => {
        if (!data) return [];

        return data.sort((a, b) => {
            // First, sort by date if it exists
            if (a.date && b.date) {
                const dateA = new Date(a.date);
                const dateB = new Date(b.date);
                if (dateA - dateB !== 0) {
                    return dateA - dateB;
                }
            }

            // Sort by division if available
            if (a.division && b.division) {
                const divComp = a.division.localeCompare(b.division);
                if (divComp !== 0) return divComp;
            }

            // Sort by salesChannel if available
            if (a.salesChannel && b.salesChannel) {
                const channelComp = a.salesChannel.localeCompare(b.salesChannel);
                if (channelComp !== 0) return channelComp;
            }

            // For AREASUM view, sort by areaId
            if (a.areaId && b.areaId) {
                return a.areaId.localeCompare(b.areaId);
            }

            // For other views, sort by BranchID
            if (a.Branchid && b.Branchid) {
                return a.Branchid.localeCompare(b.Branchid);
            }

            return 0;
        });
    };

    const formatDisplayDate = (date) => {
        if (!date) return '';
        return dayjs(date).format('DD-MM-YYYY');
    };

    const handleExport = () => {
        let excelData = [];

        // Helper function to safely convert to number
        const toNumber = (value, decimalPlaces = 2) => {
            if (value == null || value === '') return 0;
            if (typeof value === 'number') return Number(value.toFixed(decimalPlaces));
            const num = Number(value);
            return isNaN(num) ? 0 : Number(num.toFixed(decimalPlaces));
        };

        // Add headers based on view type
        if (viewType === "AREASUM") {
            if (businessSegment === 'LAZIZ' || businessSegment === 'ALL' || businessSegment === 'RETAIL') {
                excelData.push([
                    "Area", "Division", "Channel",
                    "Online Weight (KG)", "Offline Weight (KG)", "Total Weight (KG)"
                ]);
            } else {
                excelData.push([
                    "Area", "Branch", "Item ID", "Item Name", "Division", "Channel",
                    "Offline Weight (KG)", "Total Weight (KG)"
                ]);
            }
        } else if (viewType === "DAYBRSUM") {
            excelData.push([
                "Date", "Branch ID", "Branch Name", "Division", "Channel",
                "Offline Weight (KG)", "Online Weight (KG)", "Total Weight (KG)"
            ]);
        } else if (viewType === "LIST") {
            excelData.push([
                "Date", "Branch ID", "Branch Name", "Item ID", "Item Name", "Division", "Channel",
                "Online Weight (KG)", "Offline Weight (KG)", "Total Weight (KG)"
            ]);
        }

        // Add data rows
        tableData.forEach(item => {
            if (viewType === "AREASUM") {
                if (businessSegment === 'LAZIZ' || businessSegment === 'ALL' || businessSegment === 'RETAIL') {
                    excelData.push([
                        item.areaName,

                        item.division, // Already transformed to show PACKED instead of PRODUCT
                        item.salesChannel,
                        toNumber(item.onlineWeight),
                        toNumber(item.offlineWeight),
                        toNumber(item.totalQty)
                    ]);
                } else {
                    excelData.push([
                        item.areaName,
                        item.branchName,
                        item.itemId,
                        item.materialName,
                        item.division, // Already transformed to show PACKED instead of PRODUCT
                        item.salesChannel,
                        toNumber(item.offlineWeight),
                        toNumber(item.totalQty)
                    ]);
                }
            } else if (viewType === "DAYBRSUM") {
                excelData.push([
                    dayjs(item.date).format('DD-MM-YYYY'),
                    item.Branchid,
                    item.branchName,
                    item.division, // Already transformed to show PACKED instead of PRODUCT
                    item.salesChannel,
                    toNumber(item.posQty),
                    toNumber(item.onlineQty),
                    toNumber(item.totalQty)
                ]);
            } else if (viewType === "LIST") {
                excelData.push([
                    dayjs(item.date).format('DD-MM-YYYY'),
                    item.Branchid,
                    item.branchName,
                    item.itemId,
                    item.itemName,
                    item.division, // Already transformed to show PACKED instead of PRODUCT
                    item.salesChannel,
                    toNumber(item.onlineQty, 3),
                    toNumber(item.offlineQty, 3),
                    toNumber(item.totalQty, 3)
                ]);
            }
        });

        // Create workbook and worksheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Set column formats to ensure numbers are displayed correctly
        ws['!cols'] = [
            { wch: 15 },  // Area/Date
            { wch: 15 },  // Branch
            { wch: 20 },  // Item ID/Branch Name
            { wch: 20 },  // Item Name/Division
            { wch: 15 },  // Division/Channel
            { wch: 15 },  // Channel/Online Weight
            { wch: 15, z: '#,##0.00' },  // Online Weight/Offline Weight
            { wch: 15, z: '#,##0.00' },  // Offline Weight/Total Weight
            { wch: 15, z: '#,##0.00' }   // Total Weight (if applicable)
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sales Summary");

        // Generate filename
        let divisionString = selectedDivisions.length > 0 ? "_" + selectedDivisions.join("-") : "";
        const fileName = `${businessSegment}_${viewType}${divisionString}_${dayjs(startDate).format('DD-MM-YYYY')}_${dayjs(endDate).format('DD-MM-YYYY')}.xlsx`;

        // Save the file
        XLSX.writeFile(wb, fileName);
    };


    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleSearch = () => {
        fetchReportData();
        setPage(1);  // This resets pagination to page 1

    };

    // Calculate pagination indexes
    const startIndex = (page - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedData = tableData.slice(startIndex, endIndex);

    // Handle business segment change
    const handleBusinessSegmentChange = (e) => {
        setBusinessSegment(e.target.value);
        // Reset selected divisions, area and channel when business segment changes
        setSelectedDivisions([]);
        setArea("ALL");
        setSelectedChannel("ALL");
    };


    return (
        <div className="report-container-summary">
            <Header />
            <Card className="report-card-summary">
                <CardContent>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                        <Grid item xs={12} sm={6} md={1.8}>
                            <FormControl fullWidth>
                                <InputLabel>Area</InputLabel>
                                <Select
                                    value={area}
                                    onChange={(e) => setArea(e.target.value)}
                                    label="Area"
                                    disabled={areasLoading}
                                >
                                    <MenuItem value="ALL">ALL</MenuItem>
                                    {areasLoading ? (
                                        <MenuItem disabled>Loading areas...</MenuItem>
                                    ) : areas.map((area) => (
                                        <MenuItem key={area.sfAreaId} value={area.sfAreaId}>
                                            {area.sfAreaName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={1.8}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Start Date"
                                    value={startDate}
                                    onChange={(newValue) => setStartDate(newValue)}
                                    format="DD-MM-YYYY"
                                    fullWidth
                                />
                            </LocalizationProvider>
                        </Grid>

                        <Grid item xs={5} sm={6} md={1.8}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="End Date"
                                    value={endDate}
                                    onChange={(newValue) => setEndDate(newValue)}
                                    format="DD-MM-YYYY"
                                    fullWidth
                                />
                            </LocalizationProvider>
                        </Grid>

                        <Grid item xs={5} sm={6} md={1.8}>
                            <FormControl fullWidth>
                                <InputLabel>Business Segment</InputLabel>
                                <Select
                                    value={businessSegment}
                                    onChange={handleBusinessSegmentChange}
                                    label="Business Segment"
                                    disabled={businessSegmentsLoading}
                                >
                                    {businessSegmentsLoading ? (
                                        <MenuItem disabled>Loading segments...</MenuItem>
                                    ) : businessSegments.map((segment) => (
                                        <MenuItem key={segment.businessSegmentCode} value={segment.businessSegmentCode}>
                                            {segment.businessSegmentName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={5} sm={6} md={1.8}>
                            <FormControl fullWidth>
                                <InputLabel>View Type</InputLabel>
                                <Select value={viewType} onChange={(e) => setViewType(e.target.value)} label="View Type">
                                    <MenuItem value="AREASUM">Cumulative</MenuItem>
                                    <MenuItem value="DAYBRSUM">Datewise</MenuItem>
                                    <MenuItem value="LIST">List</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={5} sm={6} md={1.5}>
                            <Tooltip title={selectedDivisions.length === 0 ? "Please select at least one division" : ""}>
                                <span>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleSearch}
                                        className="MuiButton-contained-summary MuiButton-containedPrimary-summary"
                                        disabled={selectedDivisions.length === 0}
                                    >
                                        Search
                                    </Button>
                                </span>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={5} sm={6} md={1.5}>
                            <Button variant="contained" color="secondary" fullWidth onClick={handleExport} className="MuiButton-contained-summary MuiButton-containedSecondary-summary">
                                Export
                            </Button>
                        </Grid>
                    </Grid>

                    {/* Add Division and Channel Filter Section */}
                    <Grid container spacing={2} alignItems="center" mt={0}>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel id="division-multiple-checkbox-label">Divisions</InputLabel>
                                <Select
                                    labelId="division-multiple-checkbox-label"
                                    id="division-multiple-checkbox"
                                    multiple
                                    value={selectedDivisions}
                                    onChange={handleDivisionChange}
                                    input={<OutlinedInput label="Divisions" />}
                                    renderValue={(selected) => (
                                        <div className="division-chips-summary">
                                            {selected.map((value) => (
                                                <Chip key={value} label={value === "PRODUCT" ? "PACKED" : value} className="division-chip-summary" />
                                            ))}
                                        </div>
                                    )}
                                    MenuProps={MenuProps}
                                    disabled={divisionsLoading}
                                >
                                    {divisionsLoading ? (
                                        <MenuItem disabled>Loading divisions...</MenuItem>
                                    ) : getFilteredDivisions().map((division) => (
                                        <MenuItem key={division} value={division}>
                                            <Checkbox checked={selectedDivisions.indexOf(division) > -1} />
                                            <ListItemText primary={displayDivisionName(division)} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel>Channel</InputLabel>
                                <Select
                                    value={selectedChannel}
                                    onChange={handleChannelChange}
                                    label="Channel"
                                >
                                    {getAvailableChannels().map((channel) => (
                                        <MenuItem key={channel} value={channel}>
                                            {channel}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {error && <Alert severity="error" sx={{ mt: 2 }} className="error-message-summary">{error}</Alert>}

                    <div className="report-table-container-summary">
                        <div className="report-table-scroll-summary">
                            <table className="report-table-summary">
                                <thead>
                                    {viewType === "AREASUM" ? (
                                        <tr>
                                            <th>Area</th>
                                            <th>Division</th>
                                            <th>Channel</th>
                                            {(businessSegment === 'LAZIZ' || businessSegment === 'ALL' || businessSegment === 'RETAIL') && (
                                                <>
                                                    <th className="text-center-summary">Weight in KG Online</th>
                                                    <th className="text-center-summary">Weight in KG Offline</th>
                                                </>
                                            )}
                                            {(businessSegment === 'MODERN') && (
                                                <th className="text-center-summary">Weight in KG Offline</th>
                                            )}
                                            <th className="text-center-summary">Total</th>
                                        </tr>
                                    ) : viewType === "LIST" ? (
                                        <tr>
                                            <th>Date</th>
                                            <th>Branch ID</th>
                                            <th>Branch Name</th>
                                            <th>Item ID</th>
                                            <th>Item Name</th>
                                            <th>Division</th>
                                            <th>Channel</th>
                                            <th>Qty Online</th>
                                            <th>Qty Offline</th>
                                            <th>Total</th>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <th>Date</th>
                                            <th>Branch ID</th>
                                            <th>Branch Name</th>
                                            <th>Division</th>
                                            <th>Channel</th>
                                            <th>Weight in Offline (KG)</th>
                                            <th>Weight in Online (KG)</th>
                                            <th>Total Quantity</th>
                                        </tr>
                                    )}
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td
                                                colSpan={
                                                    viewType === "AREASUM"
                                                        ? (businessSegment === 'LAZIZ' || businessSegment === 'ALL' || businessSegment === 'RETAIL')
                                                            ? 9
                                                            : 8
                                                        : viewType === "LIST"
                                                            ? 10
                                                            : 8
                                                }
                                                className="report-loading-summary"
                                            >
                                                <CircularProgress />
                                            </td>
                                        </tr>
                                    ) : paginatedData.length > 0 ? (
                                        paginatedData.map((item, index) => (
                                            <tr key={index} className={index % 2 === 0 ? "row-even-summary" : "row-odd-summary"}>
                                                {viewType === "AREASUM" ? (
                                                    <>
                                                        <td>{item.areaName}</td>

                                                        <td>{item.division}</td>
                                                        <td>{item.salesChannel}</td>
                                                        {(businessSegment === 'LAZIZ' || businessSegment === 'ALL' || businessSegment === 'RETAIL') && (
                                                            <>
                                                                <td className="text-center-summary numeric-cell-summary">
                                                                    {Number(item.onlineWeight) === 0 ? '0.00' : item.onlineWeight}
                                                                </td>
                                                                <td className="text-center-summary numeric-cell-summary">
                                                                    {Number(item.offlineWeight) === 0 ? '0.00' : item.offlineWeight}
                                                                </td>
                                                            </>
                                                        )}
                                                        {businessSegment === 'MODERN' && (
                                                            <td className="text-center-summary numeric-cell-summary">
                                                                {Number(item.offlineWeight) === 0 ? '0.00' : item.offlineWeight}
                                                            </td>
                                                        )}
                                                        <td className="text-center-summary numeric-cell-summary total-cell-summary">
                                                            {Number(item.totalQty) === 0 ? '0.00' : item.totalQty}
                                                        </td>
                                                    </>
                                                ) : viewType === "LIST" ? (
                                                    <>
                                                        <td>{item.displayDate}</td>
                                                        <td>{item.Branchid}</td>
                                                        <td>{item.branchName}</td>
                                                        <td>{item.itemId}</td>
                                                        <td>{item.itemName}</td>
                                                        <td>{item.division}</td>
                                                        <td>{item.salesChannel}</td>
                                                        <td className="text-center-summary numeric-cell-summary">{item.onlineQty}</td>
                                                        <td className="text-center-summary numeric-cell-summary">{item.offlineQty}</td>
                                                        <td className="text-center-summary numeric-cell-summary total-cell-summary">{item.totalQty}</td>
                                                    </>
                                                ) : (
                                                    <>
                                                        <td>{item.displayDate}</td>
                                                        <td>{item.Branchid}</td>
                                                        <td>{item.branchName}</td>
                                                        <td>{item.division}</td>
                                                        <td>{item.salesChannel}</td>
                                                        <td className="text-center-summary numeric-cell-summary">{item.posQty}</td>
                                                        <td className="text-center-summary numeric-cell-summary">{item.onlineQty}</td>
                                                        <td className="text-center-summary numeric-cell-summary total-cell-summary">{item.totalQty}</td>
                                                    </>
                                                )}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan={
                                                    viewType === "AREASUM"
                                                        ? (businessSegment === 'LAZIZ' || businessSegment === 'ALL' || businessSegment === 'RETAIL')
                                                            ? 9
                                                            : 8
                                                        : viewType === "LIST"
                                                            ? 10
                                                            : 8
                                                }
                                                className="report-no-data-summary"
                                            >
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                {paginatedData.length > 0 && (
                                    <tfoot>
                                        <tr className="summary-row-summary">
                                            <td colSpan={
                                                viewType === "AREASUM"
                                                    ? 3 // Area, Branch, Item ID, Item Name, Division, Channel
                                                    : viewType === "LIST"
                                                        ? 7 // Date, Branch ID, Branch Name, Item ID, Item Name, Division, Channel
                                                        : 5 // Date, Branch ID, Branch Name, Division, Channel
                                            }>
                                                <strong>Total:</strong>
                                            </td>
                                            {viewType === "AREASUM" ? (
                                                <>
                                                    {(businessSegment === 'LAZIZ' || businessSegment === 'ALL' || businessSegment === 'RETAIL') && (
                                                        <>
                                                            <td className="text-center-summary numeric-cell-summary">
                                                                {tableData.reduce((sum, item) => sum + Number(item.onlineWeight || 0), 0).toFixed(2)}
                                                            </td>
                                                            <td className="text-center-summary numeric-cell-summary">
                                                                {tableData.reduce((sum, item) => sum + Number(item.offlineWeight || 0), 0).toFixed(2)}
                                                            </td>
                                                        </>
                                                    )}
                                                    {businessSegment === 'MODERN' && (
                                                        <td className="text-center-summary numeric-cell-summary">
                                                            {tableData.reduce((sum, item) => sum + Number(item.offlineWeight || 0), 0).toFixed(2)}
                                                        </td>
                                                    )}
                                                    <td className="text-center-summary numeric-cell-summary total-cell-summary">
                                                        {tableData.reduce((sum, item) => sum + Number(item.totalQty || 0), 0).toFixed(2)}
                                                    </td>
                                                </>
                                            ) : viewType === "LIST" ? (
                                                <>
                                                    <td className="text-center-summary numeric-cell-summary">
                                                        {tableData.reduce((sum, item) => sum + Number(item.onlineQty || 0), 0).toFixed(3)}
                                                    </td>
                                                    <td className="text-center-summary numeric-cell-summary">
                                                        {tableData.reduce((sum, item) => sum + Number(item.offlineQty || 0), 0).toFixed(3)}
                                                    </td>
                                                    <td className="text-center-summary numeric-cell-summary total-cell-summary">
                                                        {tableData.reduce((sum, item) => sum + Number(item.totalQty || 0), 0).toFixed(3)}
                                                    </td>
                                                </>
                                            ) : (
                                                <>
                                                    <td className="text-center-summary numeric-cell-summary">
                                                        {tableData.reduce((sum, item) => sum + Number(item.posQty || 0), 0).toFixed(2)}
                                                    </td>
                                                    <td className="text-center-summary numeric-cell-summary">
                                                        {tableData.reduce((sum, item) => sum + Number(item.onlineQty || 0), 0).toFixed(2)}
                                                    </td>
                                                    <td className="text-center-summary numeric-cell-summary total-cell-summary">
                                                        {tableData.reduce((sum, item) => sum + Number(item.totalQty || 0), 0).toFixed(2)}
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                    </tfoot>
                                )}
                            </table>
                        </div>
                        {tableData.length > 0 && (
                            <div className="report-pagination-summary">
                                <div className="report-pagination-info-summary">
                                    Showing {startIndex + 1} to {Math.min(endIndex, tableData.length)} of {tableData.length} entries
                                </div>
                                <Pagination
                                    count={Math.ceil(tableData.length / rowsPerPage)}
                                    page={page}
                                    onChange={handlePageChange}
                                    color="primary"
                                    shape="rounded"
                                    className="MuiPagination-root-summary"
                                />
                            </div>
                        )}
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default SaleSummary;



